import FiltersSearchInput from './FiltersSearchInput';

export default FiltersSearchInput;
